import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "@/views/LandingPageV2.vue";
import LayoutSelection from "@/views/LayoutSelection.vue";
import EnterDimensions from "@/views/EnterDimensions.vue";
import RenderPreview from "@/views/RenderPreview.vue";
import UserDetailsForm from "@/views/UserDetailsForm.vue";
import DefaultComponent from "@/views/DefaultComponent.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home",
		component: LandingPage,
	},
	{
		path: "/layout-selection",
		name: "layout",
		component: LayoutSelection,
	},
	{
		path: "/enter-dimensions",
		name: "dimensions",
		component: EnterDimensions,
	},
	{
		path: "/render-preview",
		name: "render",
		component: RenderPreview,
	},
	{
		path: "/user-details-form",
		name: "userDetailsForm",
		component: UserDetailsForm,
	},
	{
		path: "/select-look",
		name: "selectLook",
		component: DefaultComponent,
	},
	// {
	// 	path: "*",
	// 	name: "default",
	// 	// Add a Loader component
	// 	component: DefaultComponent,
	// },
];

const router = new VueRouter({
	routes,
});

export default router;
